// features/knowledge-base.dependencies.js

import apiKnowledgeBase from "../api";

export const loadKnowledgeBaseDependencies = async () => {
  const [tradeOfWorksRes, businessTypesRes, userRolesRes] = await Promise.allSettled([
    apiKnowledgeBase.getTradeOfWorksForDropdown(),
    apiKnowledgeBase.getBusinessTypesForDropdown(),
    apiKnowledgeBase.getUserRolesForDropdown(),
  ]);

  const extract = (res) =>
    res.status === "fulfilled" ? res.value?.data?.data || [] : [];

  return {
    tradeOfWorks: extract(tradeOfWorksRes),
    businessTypes: extract(businessTypesRes).filter((type) => type.is_activated),
    userRoles: extract(userRolesRes),
  };
};
